import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

export interface UpdateMobileHomeSegmentsPayload {
  custom_name: string;
}

export interface UpdateParams {
  id: number;
  payload: UpdateMobileHomeSegmentsPayload;
}
const update = ({ id, payload }: UpdateParams) =>
  reactQueryPatch(internalApi.settings.mobileHomeSegments.update(id), payload);

export const mobileHomeSegmentsApi = {
  update,
};
